import React from "react";
import { FiEdit } from "react-icons/fi";

export default function SummaryHeader({
  pickupPincode,
  deliveryPincode,
  packageType,
  boxes,
  paymentMode,
  codAmount,
  insuranceOption,
  invoiceValue,
  handleReset,
}) {
  return (
    <div className="w-full bg-blue-50 border border-blue-200 rounded px-4 py-3 md:px-6 md:py-4 mb-6 shadow-md sticky top-0 z-20">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        {/* Summary Info Section */}
        <div className="flex flex-wrap gap-4 md:gap-6 text-sm text-blue-900 font-medium">
          <div className="min-w-[100px]">
            <span className="block text-black">Pickup</span>
            <span className="font-semibold">{pickupPincode}</span>
          </div>
          <div className="min-w-[100px]">
            <span className="block text-black">Delivery</span>
            <span className="font-semibold">{deliveryPincode}</span>
          </div>
          <div className="min-w-[100px]">
            <span className="block text-black">Service</span>
            <span className="font-semibold">{packageType}</span>
          </div>
          {boxes.length > 0 && (
            <>
              <div className="min-w-[100px]">
                <span className="block text-black">Weight</span>
                <div className="flex flex-col gap-1 max-w-xs">
                  {boxes.map((box, i) => (
                    <div key={i} className=" text-blue-900">
                      <span className="block">
                        {/* Weight: */}
                        <b>
                          {box.noOfBoxes || 1} × {box.Weightperbox}
                        </b>
                        kg
                      </span>
                      {/* <span className="block">
                      Dimension:
                      <b>
                        {box.length} × {box.width} × {box.height}
                      </b>
                      cm
                    </span> */}
                    </div>
                  ))}
                </div>
              </div>
              <div className="min-w-[100px]">
                <span className="block text-black">Dimension</span>
                <div className="flex flex-col gap-1 max-w-xs">
                  {boxes.map((box, i) => (
                    <div key={i} className=" text-blue-900">
                      {/* <span className="block">
                      Weight:
                      <b>
                        {box.noOfBoxes || 1} × {box.Weightperbox}
                      </b>
                      kg
                    </span> */}
                      <span className="block">
                        {/* Dimension: */}
                        <b>
                          {box.length} × {box.width} × {box.height}
                        </b>
                        cm
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}

          {paymentMode === "COD" && (
            <div className="min-w-[100px]">
              <span className="block text-black">COD</span>
              <span className="font-semibold text-blue-900">₹{codAmount}</span>
            </div>
          )}
          {insuranceOption === "carrierRisk" && (
            <div className="min-w-[150px]">
              <span className="block text-black">Invoice </span>
              <span className="font-semibold text-blue-900">
                ₹{invoiceValue}
              </span>
            </div>
          )}
        </div>

        {/* Edit Button */}
        <button
          onClick={handleReset}
          className="flex items-center gap-2 text-sm px-4 py-2 bg-blue-100 text-blue-800 rounded-md hover:bg-blue-200 border border-blue-300 transition cursor-pointer"
        >
          <FiEdit className="w-4 h-4" />
          Edit Details
        </button>
      </div>
    </div>
  );
}
